<template>
  <div>
    <PageAllow controller="ReturnBaskets" action="getRefundableBaskets" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              deleteIcon
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'ReturnBaskets',
                  'generateReturnOrder'
                )
              "
              small
              color="primary"
              class="elevation-1 ms-1"
              width="110px"
              :disabled="(!showSelected.length || shopSelected == null)"
              @click="submit()"
            >
              {{ $t("ReturnBasket.create.submit") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <!-- 客户 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherShop v-model="shopSelected" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="mx-4 my-4">
        <v-card class="px-4">
          <v-row align="center" class="pt-5 pr-10" v-if="shopSelected != null">
            <v-col cols="12" md="4" sm="4" style="text-align: right">
              <span class="secondary--text text-subtitle-2 font-weight-bold">
                {{ $t("ReturnBasket.create.total_num") }}{{ $t("Global.colon") }}
              </span>
              <span class="accent--text text-subtitle-2 font-weight-bold">
                {{ total_num }}
              </span>
            </v-col>
            <v-col cols="12" md="4" sm="4" style="text-align: right">
              <span class="secondary--text text-subtitle-2 font-weight-bold">
                {{ $t("ReturnBasket.create.wait_return") }}{{ $t("Global.colon") }}
              </span>
              <span class="accent--text text-subtitle-2 font-weight-bold">
                {{ wait_return }}
              </span>
            </v-col>
            <v-col cols="12" md="4" sm="4" style="text-align: right">
              <span class="secondary--text text-subtitle-2 font-weight-bold">
                {{ $t("ReturnBasket.create.total_price") }}{{ $t("Global.colon") }}
              </span>
              <span class="accent--text text-subtitle-2 font-weight-bold">
                {{ $t("Global.money") }}{{ total_price | formatMoney }}
              </span>
            </v-col>
          </v-row>
          <v-data-table
              v-model="showSelected"
              id="order_list_table"
              :headers="headers"
              class="elevation-2 pa-4 mt-4"
              :items="orderLists"
              :show-select="shopSelected != null"
              item-key="key"
              disable-sort
              disable-pagination
              hide-default-footer
              :options.sync="options"
              :loading="loading"
          >
            <template v-slot:item.created="{ item }">
              {{ item.created | formatDate }}
            </template>
            <template v-slot:item.apply_num="{ item }">
              <v-text-field
                  v-model="item.apply_num"
                  single-line
                  dense
                  hide-details
                  type="number"
                  min="0"
                  @blur="item.apply_num = $numberFormatter.formatWithDotNoMoreThan(item.apply_num,0);resetTotal()"
              />
            </template>
            <template v-slot:item.price="{ item }">
              {{ $t("Global.money") }}{{ item.price | formatTwoDot }}
            </template>
          </v-data-table>
        </v-card>

      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import ReturnBaskets from "@/api/return_baskets";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherShop from "./plugins/SearcherShop";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 6 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  expect_time_from: "",
  expect_time_to: "",
  mode: 3,
  shop_id: null,
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherShop,
  },

  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.returnOrderManagement"),
          disabled: false,
          replace: true,
          href: "/return-orders",
        },
        {
          text: i18n.t("Nav.returnBaskets"),
          disabled: false,
          href: "/return-baskets",
        },
        {
          text: i18n.t("ReturnBasket.create.title"),
          disabled: true,
          href: "/return-baskets",
        },
      ];
      return items;
    },

    headers() {
      let headers = [
        {
          text: i18n.t("ReturnBasket.Fields.material_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("ReturnBasket.Fields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t("ReturnBasket.Fields.price"),
          align: "start",
          value: "price",
        },
        {
          text: i18n.t("ReturnBasket.Fields.wait_return"),
          align: "start",
          sortable: false,
          value: "wait_return",
          width: "200",
        },
      ];
      if (this.shopSelected) {
        headers.push(
          {
            text: i18n.t("ReturnBasket.Fields.apply_num"),
            align: "start",
            sortable: false,
            value: "apply_num",
            width: "200",
          },
        )
      }
      return headers;
    },

    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("StockOrderOUT.Fields.created_time"),
      },
      {
        key: "expect",
        text: i18n.t("StockOrderOUT.Fields.expect_time"),
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    orderLists: [],
    showSelected: [],
    options: JSON.parse(
      sessionStorage.getItem("return-baskets-new-options")
        ? sessionStorage.getItem("return-baskets-new-options")
        : JSON.stringify(defaultOptions)
    ),
    shopSelected: null,
    loading: false,
    total_num: 0,
    wait_return: 0,
    total_price: 0,
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("return-baskets-new", [])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.shopSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
      });
    },
    getRefundableBaskets() {
      this.loading = true;
      ReturnBaskets.getRefundableBaskets(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            let data = response.data.orders;
            this.orderLists = [];
            let index = 1;
            data.forEach((d) => {
              d.forEach((order) => {
                order.key = index
                order.apply_num = order.wait_return
                this.orderLists.push(order)
                index++;
              })
            })
          }
          this.loading = false;
        }.bind(this)
      );
    },
    submit() {
      if (this.showSelected.length) {
        this.$store.dispatch("fullscreenLoading");
        let postData = {order_details:[]};
        this.showSelected.forEach((d) => {
          postData.order_details.push({
            material_id: d.material_id,
            auto_flg: d.auto_flg,
            apply_num: d.apply_num,
            price: d.price,
            order_ids: d.order_ids
          })
        })
        ReturnBaskets.generateReturnOrder(postData).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.showSelected = [];
              this.getRefundableBaskets()
              this.$snackbar.success(i18n.t("ReturnBasket.Messages.success"));
              this.$router.push("/return-baskets");
            }
            this.$store.dispatch("fullscreenLoadingStop");
            this.loading = false;
          }.bind(this)
        );
      }
    },
    resetTotal() {
      this.total_num = 0;
      this.wait_return = 0;
      this.total_price = 0;
      if (this.showSelected.length) {
        this.showSelected.forEach((d) => {
          this.total_num += Number(d.apply_num);
          this.wait_return += d.wait_return;
          this.total_price += Number(d.apply_num) * d.price;
        })
      }
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getRefundableBaskets()
        sessionStorage.setItem(
          "return-baskets-new-options",
          JSON.stringify(this.options)
        );
      },
    },
    shopSelected: {
      handler() {
        this.options.shop_id = this.shopSelected ? this.shopSelected.id : null;
        this.showSelected = [];
      },
    },
    showSelected: {
      handler() {
        this.resetTotal()
      }
    },
  },
};
</script>